
/*
 *
 * Date: 2025
 * Description: Payment form for payment edit or add
 * Author: Philippe Leroux @SKITSC
 *
 */


//Modules
import { ReactElement } from "react";
import { Box , Grid , Typography , Button , TextField , MenuItem, InputAdornment } from "@mui/material";

//Interfaces
import { i_modal_form_props } from "../../interfaces/utility.interface";
import { formatDateTimeLocal } from "../../utils/utility";

const PaymentForm = ( props : i_modal_form_props ) : ReactElement => {
    const F = props.form
    const E = props.errors
    const handleField = ( event : React.ChangeEvent<HTMLInputElement> ) => {
        const { name, value } = event.target
        if(name === 'amount'){
            let correctedAmount = value .replace(/[^0-9.]/g, "") .replace(/(\..*?)\..*/g, "$1");
            const match = correctedAmount.match(/^(0|[1-9]\d*)(?:\.\d{0,2})?/);
            correctedAmount = match ? match[0] : "";
            props.setForm({ ...F, payment: { ...F.payment, [name]: correctedAmount } });
        }else{
            if(name === 'date'){
                const epoch = Math.floor(new Date(value).getTime() / 1000);
                props.setForm({...F, payment: {...F.payment, [name]: epoch}});
            }else{
                props.setForm({...F, payment : { ...F.payment, [name] : value}})
            }
        }
    }
    return (
        <Box>
            <Grid container>
                <Grid size={3} sx={{ alignItems : 'center' , alignContent : 'center'}}>
                    <Typography variant={"h6"}>Amount*:</Typography>
                </Grid>
                <Grid size={9}>
                    <TextField name={"amount"} value={F.payment.amount} slotProps={ { input : { endAdornment : <InputAdornment position="end">$</InputAdornment>}}} onChange={handleField} error={E.payment.amount!== ''? true : false} helperText={E.payment.amount} fullWidth sx={{ maxWidth : '200px'}}/>
                </Grid>
                <Grid size={3} mt={2} sx={{ alignItems : 'center' , alignContent : 'center'}}>
                    <Typography variant={"h6"}>Payment type*:</Typography>
                </Grid>
                <Grid size={9} mt={2}>
                    <TextField select name={"type"} value={F.payment.type === "" ? 'none' : F.payment.type} onChange={handleField} error={E.payment.type!== ''? true : false} helperText={E.payment.type} sx={{ maxWidth : '300px'}} fullWidth>
                        <MenuItem value={"none"} disabled>Select a payment type</MenuItem>
                        <MenuItem value={"bank_transfer"}>Bank Transfer</MenuItem>
                        <MenuItem value={"cheque"}>Cheque</MenuItem>
                        <MenuItem value={"cash"}>Cash</MenuItem>
                        <MenuItem value={"interact_transfer"}>Interac Transfer</MenuItem>
                        <MenuItem value={"wire_transfer"}>Wire Transfer</MenuItem>
                        <MenuItem value={"card"}>Credit/Debit Card</MenuItem>
                        <MenuItem value={"other"}>Other</MenuItem>
                    </TextField>
                </Grid>
                <Grid size={3} mt={2}>
                    <Typography variant={"h6"}>Note:</Typography>
                </Grid>
                <Grid size={9} mt={2}>
                    <TextField multiline rows={4} name={"note"} value={F.payment.note} onChange={handleField} error={E.payment.note!== ''? true : false} helperText={E.payment.note} fullWidth/>
                </Grid>
                <Grid size={3} mt={2}>
                    <Typography variant={"h6"}>Payment date:</Typography>
                </Grid>
                <Grid size={9} mt={2}>
                    <TextField type={"datetime-local"} name={"date"} value={formatDateTimeLocal(new Date(F.payment.date * 1000))} onChange={handleField} fullWidth/>
                </Grid>
                <Grid size={3} mt={2}>
                    <Typography variant={"h6"}>Maybe img upload here ?:</Typography>
                </Grid>
                <Grid size={9} mt={2}>
                    <Box sx={{ height : '100px' , border : '1px solid black'}}>
                        <Button variant={"contained"} sx={{ display : 'block', marginLeft : 'auto' , marginRight: 'auto' , marginTop : '30px'}} color={"primary"}>Upload a picture</Button>
                    </Box>
                </Grid>
                <Grid size={12} sx={{ marginTop : '1vh'}}>
                    <Button variant={"contained"} sx={{ marginLeft : 'auto' , marginRight : 'auto' , display : 'block', fontSize : 18}} color={"primary"} onClick={() => props.callback(F.index === -1 ? 'add' : 'put')}>Submit</Button>
                </Grid>
            </Grid>
        </Box>
       )
}

export default PaymentForm;